const contactForm = document.getElementById("contact-form");
const contactFormSubmitButton = contactForm.querySelector("button");

function clearAllErrors(formElement) {
	const formFields = formElement.querySelectorAll("input, textarea");
	formFields.forEach((field) => {
		field.classList.remove("error");
	});
	const formErrors = formElement.querySelectorAll("div.error, div.success");
	formErrors.forEach((error) => {
		error.parentElement.removeChild(error);
	});
}

function genericError(formElement, message) {
	const errorElement = document.createElement("div");
	errorElement.classList.add("error");
	errorElement.innerText = message;
	formElement.appendChild(errorElement);
}

async function contactFormSubmit(recaptchaToken) {
	const contactFormUrl = `${apiUrl}/contact`;
	const contactFormObj = {
		name: contactForm.querySelector("#name").value,
		email: contactForm.querySelector("#email").value,
		phone: contactForm.querySelector("#phone").value,
		message: contactForm.querySelector("#message").value,
		token: recaptchaToken,
		site: siteId,
	};
	contactForm.querySelector("button").disabled = true;
	contactForm.querySelector("button").innerText = "Sending...";

	clearAllErrors(contactForm);

	const request = await asyncRequest({
		url: contactFormUrl,
		method: "POST",
		data: JSON.stringify(contactFormObj),
		headers: { "Content-Type": "application/json;charset=UTF-8" },
	});

	if (request.status === 200) {
		contactForm.querySelector("button").disabled = false;
		contactForm.querySelector("button").innerText = "Send Message";
		const theResponse = JSON.parse(request.responseText);
		if (theResponse.error) {
			if (typeof theResponse.error === "string") {
				genericError(contactForm, theResponse.error);
			}
			if (Array.isArray(theResponse.error)) {
				theResponse.error.forEach((error) => {
					const theField = contactForm.querySelector(`#${error.id}`);
					theField.classList.add("error");
					const errorElement = document.createElement("div");
					errorElement.classList.add("error");
					errorElement.innerText = error.message;
					theField.insertAdjacentElement("afterend", errorElement);
				});
			}
		}
		if (theResponse.success) {
			const successElement = document.createElement("div");
			successElement.classList.add("success");
			successElement.innerText = "Thanks for contacting us. We'll get back to you as soon as possible.";
			contactForm.appendChild(successElement);
		}
	} else {
		genericError(contactForm, "Error, Please Refresh page and try again");
	}
}

function captchaHandler(e) {
	e.preventDefault();
	grecaptcha.ready(() => {
		grecaptcha.execute(recaptcha, { action: "submit" }).then((token) => {
			contactFormSubmit(token);
		});
	});
}

contactForm.addEventListener("submit", captchaHandler);
contactFormSubmitButton.removeAttribute("disabled");
